(function($){
    $(document).ready(function(){
      handleIOSdevice();
      initHeaderDesktopCustomerService();
      initMegamenuDesktop();
      initMenuMobile();
      initHeaderMobile();
      initFooterMobile();
    });
})(jQuery);

// -------------- VIEWPORT IOS ---------------------------------------- //
let handleIOSdevice = function () {
  const addMaximumScaleToMetaViewport = () => {
    const el = document.querySelector("meta[name=viewport]");

    if (el !== null) {
      let content = el.getAttribute("content");
      let re = /maximum\-scale=[0-9\.]+/g;

      if (re.test(content)) {
        content = content.replace(re, "maximum-scale=1.0");
      } else {
        content = [content, "maximum-scale=1.0"].join(", ");
      }

      el.setAttribute("content", content);
    }
  };

  const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
  const checkIsIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (checkIsIOS()) {
    disableIosTextFieldZoom();
  }
};

// -------------- HEADER DESKTOP CUSTOMER SERVICE BTN ----------------- //
let initHeaderDesktopCustomerService = function () {
  const $btn = $("#customer-service-desktop");
  let closeTimer;

  const open = () => {
    clearTimeout(closeTimer);
    $btn.addClass('opened').attr('aria-expanded', 'true');
  };

  const close = () => {
    closeTimer = setTimeout(() => {
      $btn.removeClass('opened').attr('aria-expanded', 'false');
    }, 150);
  };

  /* Hover */
  $btn.on("mouseenter", open);
  $btn.on("mouseleave", close);

  /* Focus */
  $btn.on("focusin", open);
  $btn.on("focusout", close);

   /* close with ESC */
  $btn.on("keydown", function(e){
    if(e.key === "Escape" || e.key === "Esc"){
      close();
      $btn.focus();
    }
  });
};

// -------------- MEGAMENU DESKTOP -------------------------------- //
let initMegamenuDesktop = function () {
  const $megamenu = $("#megamenu-product");
  const $trigger = $("#product-link");
  let closeTimer;

  $trigger.on("click", e => e.preventDefault());

  const openMenu = () => {
    clearTimeout(closeTimer);
    $trigger.addClass("active").attr("aria-expanded", "true");
    $megamenu.addClass("opened").attr("aria-hidden", "false");
  };

  const closeMenu = () => {
    closeTimer = setTimeout(() => {
      $trigger.removeClass("active").attr("aria-expanded", "false");
      $megamenu.removeClass("opened").attr("aria-hidden", "true");
    }, 120);
  };

  /* Hover */
  $trigger.on("mouseenter", openMenu);
  $megamenu.on("mouseenter", openMenu);

  $trigger.on("mouseleave", closeMenu);
  $megamenu.on("mouseleave", closeMenu);

  /* Focus */
  $trigger.on("focusin", openMenu);
  $megamenu.on("focusin", openMenu);

  $trigger.on("focusout", closeMenu);
  $megamenu.on("focusout", closeMenu);

  /* close with ESC */
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeMenu();
      $trigger.focus();
    }
  });
};

// -------------- HEADER MOBILE ON USER SCROLL --------------------- //
let initHeaderMobile = function () {
  if ($(window).width() >= 992) return;

  const $header = $('.header-main-wrapper header.header');
  let lastScrollTop = 0;
  const scrollThreshold = 10;

  $(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();

    // Ignore tiny scrolls
    if (Math.abs(currentScroll - lastScrollTop) < scrollThreshold) {
      return;
    }

    // Scroll down = Hide
    if (currentScroll > lastScrollTop && currentScroll > $header.outerHeight()) {
      $header.addClass('is-hidden');
    } 
    // Scroll up = Show
    else {
      $header.removeClass('is-hidden');
    }

    lastScrollTop = currentScroll;
  });
}

// -------------- MOBILE MENU HEADER  ------------------------ //
let initMenuMobile = function () {

  if ($(window).width() < 992) { 

    const $btnMenuMobile = $("#btn-menu-mobile");
    const $menuMobileContent = $(".menu-mobile-content");
    const $btnCloseMenuMobile = $(".close-menu-main-mobile");
    const $mobileProductWrapper = $("#mobile-product-wrapper");
    const $menuProductMobile =  $(".menu-product-mobile-content");
    const $btnCloseMenuProductMobile = $(".close-menu-product-mobile");
  
    // Main mobile menu
    $btnMenuMobile.on("click", function(){
      $menuMobileContent.toggleClass("open");
    });
  
    $btnCloseMenuMobile.on("click", function(){
      $menuMobileContent.toggleClass("open");
    });
  
    // Product mobile menu
    $mobileProductWrapper.on("click", function(){
      $menuProductMobile.addClass("open");
    });
  
    $btnCloseMenuProductMobile.on("click", function(){
      $menuProductMobile.removeClass("open");
    });
  
    $(".btn-open-category").on("click", function (e) {
      e.preventDefault();
  
      const index = $(this).data("category-index");
  
      $(".menu-category-product-content").removeClass("open");
      
      $(`.menu-category-product-content[data-category-index="${index}"]`)
        .addClass("open");
    });
  
    // RETOUR AUX CATÉGORIES
    $(".btn-back-to-products, .close-menu-category-product").on("click", function () {
      $(this).closest(".menu-category-product-content").removeClass("open");
    });
  }
};

// -------------- MOBILE VIEW FOOTER  ------------------------ //
let initFooterMobile = function () {
  if ($( window).width() < 576) {
    $(".footer-menu-list .paragraph").on("click", function () {
      const $wrapper = $(this).closest(".footer-menu-list");
      $(this).toggleClass("open");
      $wrapper.toggleClass("open");
      $wrapper.find(".navbar-nav").first().toggleClass("open");
    });
  }
};
